import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import './MarketChartsSkeleton.styles.scss';

/**
 * Skeleton component for Market Charts section
 * Displays loading state for market sales trend and market share charts
 */
const MarketChartsSkeleton: React.FC = () => {
  return (
    <div className="market-charts-skeleton">
      {/* Market Sales Trend Chart Skeleton */}
      <div className="sales-trend-skeleton">
        <div className="chart-header-skeleton">
          <Skeleton width="15rem" height="1.25rem" />
          <div className="filter-skeleton">
            <Skeleton width="10rem" height="2rem" borderRadius="0.5rem" />
            <Skeleton width="8rem" height="2rem" borderRadius="0.5rem" />
          </div>
        </div>
        <Skeleton width="100%" height="20rem" borderRadius="0.75rem" />
      </div>

      {/* Market Share by Volume Chart Skeleton */}
      <div className="market-share-skeleton">
        <Skeleton width="12rem" height="1.25rem" style={{ marginBottom: '1rem' }} />
        <Skeleton width="100%" height="18rem" borderRadius="0.75rem" />
      </div>
    </div>
  );
};

export default MarketChartsSkeleton;
